intakesModule = angular.module('intakesModule')
intakesModule.controller('PreviewController', ($scope, $state, $stateParams, $log)->

)